import apiClient from "../config/apiClient";

// Pay (clear) one or more pending bills using the patient's wallet balance
// (account_deposits). Mirrors the paypoint "apply deposit" flow: the backend
// applies the deposit, records a usage entry, and settles each bill.
// items: [{ id, amount }] — the pending transactions to clear.
export const payBillsFromWallet = async (items) => {
  const token = window.localStorage.getItem("token");
  return await apiClient.post(
    `/public/portal?url=transactions/process-credit`,
    {
      payment_method: "Wallet",
      items,
    },
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
};
